import React from 'react';
import { DollarSign, Calendar, Star, Package, Users, TrendingUp } from 'lucide-react';
import { StatsGrid } from '../../admin';

const AnalyticsTab = ({ vendor, vendorProfile }) => {
  // Calculate analytics from vendor data
  const totalEarnings = vendor?.total_earnings || vendorProfile?.total_earnings || 0;
  const totalBookings = vendor?.total_bookings || vendorProfile?.total_bookings || vendor?.bookings?.length || 0;
  const averageRating = vendorProfile?.average_rating || 0;
  const totalReviews = vendorProfile?.total_reviews || vendor?.reviews?.length || 0;
  const totalServices = vendorProfile?.vendor_services?.length || vendorProfile?.vendorServices?.length || 0;
  const totalPackages = vendorProfile?.vendor_service_packages?.length || vendorProfile?.vendorServicePackages?.length || 0;

  const formatCurrency = (amount) => {
    if (typeof amount === 'number') {
      return `$${amount.toFixed(2)}`;
    }
    return '$0.00';
  };

  const formatRating = (rating) => {
    if (rating && rating > 0) {
      return `${Number(rating).toFixed(1)}/5.0`;
    }
    return 'N/A';
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="mb-4 sm:mb-6">
        <h3 className="text-base sm:text-lg font-semibold text-gray-900">Vendor Analytics</h3>
        <p className="text-sm text-gray-600 mt-1">Overview of vendor performance and statistics</p>
      </div>

      <StatsGrid 
        stats={[
          {
            key: 'earnings',
            title: 'Total Earnings',
            value: formatCurrency(totalEarnings),
            icon: DollarSign,
            variant: 'success'
          },
          {
            key: 'bookings',
            title: 'Total Bookings',
            value: totalBookings.toString(),
            icon: Calendar,
            variant: 'info'
          },
          {
            key: 'rating',
            title: 'Average Rating',
            value: formatRating(averageRating),
            icon: Star,
            variant: 'warning'
          },
          {
            key: 'reviews',
            title: 'Total Reviews',
            value: totalReviews.toString(),
            icon: Star,
            variant: 'default'
          },
          {
            key: 'services',
            title: 'Services',
            value: totalServices.toString(),
            icon: Package,
            variant: 'info'
          },
          {
            key: 'packages',
            title: 'Packages',
            value: totalPackages.toString(),
            icon: Package,
            variant: 'default'
          }
        ]}
        columns={3}
      />

      {/* Additional Analytics Section */}
      {/* <div className="mt-6 sm:mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-gray-700">Completion Rate</h4>
            <TrendingUp className="w-4 h-4 text-gray-400" />
          </div>
          <p className="text-2xl font-bold text-gray-900">
            {totalBookings > 0 ? '100%' : 'N/A'}
          </p>
          <p className="text-xs text-gray-500 mt-1">Based on completed bookings</p>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-6">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-gray-700">Response Time</h4>
            <Calendar className="w-4 h-4 text-gray-400" />
          </div>
          <p className="text-2xl font-bold text-gray-900">N/A</p>
          <p className="text-xs text-gray-500 mt-1">Average response time</p>
        </div>
      </div> */}
    </div>
  );
};

export default AnalyticsTab;

